/* eslint-disable jsx-a11y/alt-text */
import { useAuth0 } from '@auth0/auth0-react';
import { CircularProgress, IconButton, TableContainer } from '@material-ui/core';
import Dialog from "@material-ui/core/Dialog";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import Pagination from '@material-ui/lab/Pagination';
import ArchiveIcon from '@mui/icons-material/Archive';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import PrintIcon from '@mui/icons-material/Print';
import PreSchoolService from 'Lib/API/PreSchool';
import sortImg from 'assets/icons/sort-able-svg.svg';
import Action from 'components/ActionPopOver';
import { CheckBox } from "components/CheckBox/CheckBox";
import AlertDialog from 'components/Dialog';
import MyButton from 'components/MyButton';
import SearchComp from 'components/Searchcomponent';
import SendLetter from "components/SendLetter/SendLetter";
import RightDrawer from 'components/drawer';
import Loader from 'components/loader/Loader';
import ProgressBar from 'components/progressBar/progressbar';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { useHistory } from 'react-router-dom';
import { useReactToPrint } from "react-to-print";
import { setClassName } from 'services/api/education';
import * as XLSX from "xlsx";
import { sanitizeRows } from "utils/exportSanitize";
import './index.scss';

import SuccessModal from 'components/SuccessModal/SuccessModal';
import { formatDate, numberFormat } from 'helper';
import { number } from 'prop-types';
import { getFormDataHandler } from 'utils/formDataHelper';
import ClassDrawer from './schoolComponent/ClassDrawer';
import { fontConfig } from "theme/fontConfig";
const TableCellHead = withStyles((theme) => ({
  root: {
    height: '39px',
    padding: '0px 20px',
    borderBottom: 'none',
    fontFamily: fontConfig.GeneralTableCellHeadFont.family,
  },
}))(TableCell);

const TableCellBody = withStyles((theme) => ({
  root: {
    height: '65px',
    padding: '0px 20px',
    fontFamily: fontConfig.GeneralTableCellBodyFont.family,
    color: '#4f4f4f',
  },
}))(TableCell);

const columns_for_header = [
  {
    id: "className",
    displayName: "Class Name",
    headerName: "Class Name",
    field: "className",
    flex: 1,
  },
  {
    id: "date",
    displayName: "Date",
    headerName: "Date",
    field: "date",
    flex: 1,
  },
  {
    id: "classStartDate",
    displayName: "Registration Start Date",
    headerName: "Registration Start Date",
    field: "classStartDate",
    flex: 1,
  },
  {
    id: "classEndDate",
    displayName: "Registration End Date",
    headerName: "Registration End Date",
    field: "classEndDate",
    flex: 1,
  },
  {
    id: "ageRange",
    displayName: "Age Range",
    headerName: "Age Range",
    field: "ageRange",
    flex: 1,
  },
  {
    id: "allowNonMembers",
    displayName: "Non Member",
    headerName: "Non Member",
    field: "allowNonMembers",
    flex: 1,
  },
  {
    id: "participants",
    displayName: "Participants",
    headerName: "Participants",
    field: "participants",
    flex: 1,
  },
  {
    id: "total_cost",
    displayName: "Cost",
    headerName: "Cost",
    field: "total_cost",
    flex: 1,
  },
];

const CurrentClasses = ({
  setOpenDialog,
  archived,
  duplicate,
  setError,
  newClassName,
  setData,
  setDisabled,
  setClassesCount,
  sortCharged,
  handleSort,
  setSorting,
  sorting,
  toggle,
  searchValue,
  handleInputChange,
  ...props
}) => {
  const printTableRef = useRef();


  const [openDialog, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const { getAccessTokenSilently } = useAuth0();
  const [selectionModel, setSelectionModel] = useState([]);
  const [data, addData] = useState();
  const history = useHistory();
  const [count, setCount] = useState();
  const [activeClassCount, setActiveClassCount] = useState();
  const [archivedCount, setArchivedCount] = useState();
  const dispatch = useDispatch()
  const [selectionClass, setSelectionClass] = useState([]);
  const [activeClassPage, setActiveClassPage] = useState(0);
  const [archivedClassPage, setArchivedClassPage] = useState(0);
  const [deleteClassId, setDeleteClassId] = useState(null);
  const [duplicateClassId, setDuplicateClassId] = useState(null);
  const [archiveClassId, setArchiveClassId] = useState([]);
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [drawerData, setDrawerData] = useState({});
  const [check, setCheck] = useState([]);
  const [checkAll, setCheckAll] = useState(false)
  const [csvData, setExportData] = useState([]);
  const [exportType, setExportType] = useState("");
  const [openLetterModal, setOpenLetterModal] = useState(false);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [sendLetterLoading, setSendLetterLoading] = useState(false);
  const [exportAllTable, setExportAllTable] = useState(false);
  const [participantExportData, setParticipantExportData] = useState([]);
  const [enableExportingParticipants, setEnableExportingParticipants] = useState(false);
  const [archiveStatus, setArchiveStatus] = useState(false);
  const [exportAllClassesParticipants, setExportAllClassesParticipants] = useState(false);
  const [exportAllLoading, setExportAllLoading] = useState(false);
  const [exportAllClassesParticipantsLoading, setExportAllClassesParticipantsLoading] = useState(false)

  const organization = localStorage.getItem('organization')
    ? JSON.parse(localStorage.getItem('organization'))
    : null;
  const orgKey = organization?.orgkey;


  useEffect(() => {
    const data = {
      class_Ids: selectionModel,
      archived: true,
    };
    //post the data
    if (archived) {
      setOpen(true);
      addData(data);
    }
  }, [archived]);

  const deleteClass = async (id) => {
    try {
      setConfirmLoading(true);
      const token = await getAccessTokenSilently();
      await PreSchoolService.deleteClass(token, id);
      toastr.success('Success', 'Class Deleted Successfully!');
      setRefresh(!refresh);
    } catch (error) {
      toastr.error('Error', error?.data?.message || 'Something went wrong!');
    } finally {
      setDeleteClassId(null);
      setConfirmDialog(false);
      setConfirmLoading(false);
      setIsDrawerOpen(false);
    }
  };
  const archiveClass = async () => {
    const data = {
      ids: archiveClassId,
      status: archiveStatus,
    };
    try {
      setConfirmLoading(true);
      const token = await getAccessTokenSilently();
      await PreSchoolService.archiveClass(token, data);
      toastr.success('Success', 'Class Archived Successfully!');
      setRefresh(!refresh);
      setCheck([]);
      setCheckAll(false);
    } catch (error) {
      toastr.error('Error', error?.data?.message || 'Something went wrong!');
    } finally {
      setArchiveClassId([]);
      setConfirmDialog(false);
      setConfirmLoading(false);
      setIsDrawerOpen(false);
    }
  };

  const duplicateClass = async (duplicateClassId) => {
    const payload = {
      classId: duplicateClassId,
    };
    try {
      setConfirmLoading(true);
      const token = await getAccessTokenSilently();
      await PreSchoolService.duplicateClass(token, payload);
      toastr.success('Success', 'Class Duplicated Successfully!');
      setRefresh(!refresh);
    } catch (error) {
      toastr.error('Error', error?.data?.message || 'Something went wrong!');
    } finally {
      setDuplicateClassId(null);
      setConfirmDialog(false);
      setConfirmLoading(false);
    }
  };

  // This function called when Archived toggle button is clicked and when the page is changed in pagaination (this function will not used in useEffect)
  const getArchivedClasses = async (page) => {
    try {
      enableLoading(true);
      const token = await getAccessTokenSilently();
      const result = await PreSchoolService.getArchivedClasses(
        token,
        page || archivedClassPage + 1,
        30
      );
      setList(result?.payload?.data);
      setCount(result?.payload?.pagination?.count);
      setArchivedCount(result?.payload?.pagination?.count);
    } catch (error) {
      toastr.error('Error', error?.data?.message || 'Something went wrong!');
    } finally {
      enableLoading(false);
    }
  };

  useEffect(() => {
    if (selectionModel.length > 1) {
      setError('You Can Duplicate 1 Class only!');
      setDisabled(true);
    } else if (selectionModel.length === 1) {
      const data = {
        selectedClassId: selectionModel[0],
        newClassName: newClassName,
      };
      setOpenDialog(true);
      setData(data);
    }
  }, [duplicate, newClassName]);

  useEffect(() => {
    if (selectionModel.length > 1) setDisabled(true);
    else setDisabled(false);
  }, [selectionModel]);
  const enableLoading = (value) => {
    setLoading(value);
  };
  async function getClassesList() {
    enableLoading(true);
    try {
      const token = await getAccessTokenSilently();
      const result = await PreSchoolService.getClassesList(
        token,
        sorting?.search ? 1 : activeClassPage + 1,
        30,
        sorting
      );
      setList(result?.payload?.data);
      setCount(result?.payload?.pagination?.count);
      setActiveClassCount(result?.payload?.pagination?.count);
    } catch (error) {
      toastr.error('Error', error?.data?.message || 'Something went wrong!');
    } finally {
      enableLoading(false);
    }
  }
  React.useEffect(() => {
    if (toggle) {
      getClassesList();
    } else {
      getArchivedClasses();
    }
  }, [activeClassPage, refresh, sorting, toggle]);

  const onClickEvent = (data) => {
    if (data.field !== 'number_of_participants')
      history.push(`/class-details/${data.id}`);
    else history.push(`/class-participants/${data.id}`);
  };

  const columns = [
    {
      field: 'class_name',
      headerName: 'CLASS NAME',
      width: 250,
      renderCell: (data) => {
        return (
          <div className="user-cotainer-home">{data?.row?.class_name}</div>
        );
      },
    },
    {
      field: 'year',
      headerName: 'YEAR',
      width: 150,
      // editable: true,
      renderCell: (data) => (
        <div style={{ color: 'grey' }}>{data?.row?.year}</div>
      ),
    },
    {
      field: 'registration',
      headerName: 'REGISTRATION',
      width: 150,
      // editable: true,
      renderCell: (data) => (
        <div style={{ color: 'grey' }}>{data?.row?.ageRange}</div>
      ),
    },
    {
      field: 'genders',
      headerName: 'SEX',
      width: 150,
      // editable: true,
      renderCell: (data) => (
        <div style={{ color: 'grey' }}>{data?.row?.ageRange}</div>
      ),
    },
    {
      field: 'non_member',
      headerName: 'NON-MEMBER',
      width: 150,
      renderCell: (data) => <div>{data?.row?.non_member}</div>,
    },
    {
      field: 'number_of_participants',
      headerName: 'NUMBER OF PARTICIPANTS',
      width: 200,
      renderCell: (data) => (
        <div className="participants">
          <div className="participants-number">
            {data?.row?.ParticipantObj
              ? data?.row?.ParticipantObj?.numOfParticipants
              : 0}
          </div>
          <div className="participants-view">View participants</div>
        </div>
      ),
    },
    {
      field: 'total_cost',
      headerName: 'TOTAL COSE',
      // description: "This column has a value getter and is not sortable.",
      // sortable: false,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: 'green' }}>${data?.row?.total_cost}</div>
      ),
    },
  ];

  const onCheckboxChange = (e, row) => {
    const { checked } = e.target;
    if (checkAll) return;
    if (!checked) {
      setCheckAll(false)
      setCheck((prev) => {
        const checkClone = prev.filter((item) => item._id !== row._id);
        return [...checkClone];
      });
      return;
    } else if (csvData.length && check.length === csvData.length) {
      setCheckAll(true)
    }
    setCheck((prev) => [
      ...prev,
      row

    ]);
  };

  const compareDate = (date) => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const date1 = new Date(date);
    if (date1.toDateString() === today.toDateString()) {
      return <span style={{ color: '#2555EF' }}>Today</span>;
    } else if (date1.toDateString() === tomorrow.toDateString()) {
      return <span style={{ color: '#2555EF' }}>Tomorrow</span>;
    } else {
      return formatDate({ date, formatType: "defaultWithUTC" })
    }
  };



  const calculateParticipantsPercentage = (row) => {
    const totalParticipants = row?.participantsDetails?.total;
    const maximumParticipants = row?.class_details?.maximum_participants
    const percentage = (totalParticipants / maximumParticipants) * 100;
    return percentage >= 0 ? Math.round(percentage) : 0;
  };


  const onCheckboxAllChange = (e) => {
    setCheckAll(e.target.checked)
    if (!e.target.checked) {
      setCheck([]);
    }
  };

  const getExportData = async (value) => {
    const token = await getAccessTokenSilently();
    const ides = checkAll ? [] : check.map(item => {
      return item._id
    });
    const body = { classesIds: ides }
    PreSchoolService.exportClass(token, body)
      .then((res) => {
        setExportData(res?.payload?.data);
        setExportType(value);
      })
      .catch((err) => { });
  };
  useEffect(() => {
    getExportData();
  }, [checkAll]);


  const handleSendLetter = async (templateData) => {
    setSendLetterLoading(true);
    const token = await getAccessTokenSilently();
    const bodyData = {
      classIds: checkAll ? [] : check.map((item) => item._id),
      all: checkAll ? true : false,
      ...templateData
    }

    PreSchoolService.sendClassParticipantLetter(token, bodyData)
      .then((response) => {
        setOpenSuccessModal(true);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong!");
      }).finally(() => {
        setSendLetterLoading(false);
        setOpenLetterModal(false);
      });
  };


  const calculateTotalParticipants = () => {
    let total = 0;
    check.forEach((item) => {
      total += item?.participantsDetails?.total;
    });
    return total;
  };

  const handleArchiveButton = () => {
    const dataList = checkAll ? csvData : check
    const ides = dataList?.map(item => {
      return item._id
    })
    setArchiveClassId(ides);
    setArchiveStatus(true);
    setConfirmDialog(true);
  }
  const getExportFileName = () => {
    if (exportAllClassesParticipants) {
      return "Students.xlsx"
    } else if (exportAllTable) {
      return `${drawerData?.class_name}.xlsx`
    } else if (check?.length === 1) {
      return `${check[0]?.class_name}.xlsx`
    } else {
      return "Classes.xlsx"
    }
  }
  const handlePrint = useReactToPrint({
    content: () => printTableRef.current,
    documentTitle: getExportFileName(),

  });
  useEffect(() => {
    if (exportType == "print") {
      handlePrint();
    }
    setExportType("");
  }, [exportType]);


  let customCsvData = []
  let myData =
    csvData?.length !== 0
    && csvData?.map((item) => {
      const data = {
        className: item?.class_name,
        date: item?.year,
        classStartDate: item?.class_start_date ? formatDate({ date: item?.class_start_date, formatType: "defaultWithUTC" }) : "",
        classEndDate: item?.class_end_date ? formatDate({ date: item?.class_end_date, formatType: "defaultWithUTC" }) : "",
        ageRange: `${item?.class_details?.ageStart} - ${item?.class_details?.ageEnd}`,
        allowNonMembers: item?.allow_non_members_register,
        participants: `${item?.participantsDetails?.total} / ${item?.class_details?.infiniteParticipants ? '∞' : item?.class_details?.maximum_participants}`,
        total_cost: numberFormat({ number: item?.class_pricing?.total_cost, decimal: 2, style: "currency" }),
      };
      customCsvData.push(data);
    })



  const getExportParticipantsData = async () => {
    const token = await getAccessTokenSilently();
    if (exportAllClassesParticipants) {
      setExportAllClassesParticipantsLoading(true)
    } else {
      setExportAllLoading(true)
    }
    const body = {
      classId: !exportAllClassesParticipants ? drawerData?._id : undefined,
      classIds: exportAllClassesParticipants ? checkAll ? [] : check.map((item) => item._id) : undefined,
      participantsIds: []
    }
    PreSchoolService.exportClassParticipant(token, body)
      .then((res) => {
        setParticipantExportData(res?.data);
        setEnableExportingParticipants(true)
      })
      .catch((err) => {
        setEnableExportingParticipants(false)
        toastr.error("Error", err?.data?.message || "Something went wrong!");
      })
      .finally(() => {
        if (exportAllClassesParticipants) {
          setExportAllClassesParticipantsLoading(false)
        } else {
          setExportAllLoading(false)
        }
      });
  };
  const totalPaymentCalculation = (approveTotalPaid, registerTotalPaid) => {
    const totalPayment = +approveTotalPaid || 0 + +registerTotalPaid || 0
    return numberFormat({ number: totalPayment, decimal: 2, style: "currency" })
  }


  const excelSheet = () => {
    const arr = [];
    const dataExport = checkAll ? csvData : check
    if (exportAllTable || exportAllClassesParticipants) {
      participantExportData.map((item) => {
        const data = {
          ...(exportAllClassesParticipants ? {
            ["Class Name"]: item?.class?.class_name,
          } : {}),
          ["First Name"]: item?.firstName,
          ["Last Name"]: item?.lastName,
          ["Date Of Birth"]: item?.dateOfBirth ? formatDate({ date: item?.dateOfBirth, formatType: "defaultWithUTC" }) : "",
          ["School Grade"]: item?.class?.class_details?.grade,
          ["Registration Status"]: item?.registrationStatus,
          ["Payment Status"]: item?.payment?.approve?.status,
          ["Payment Amount"]: (item?.payment?.approve?.totalPaid || item?.payment?.register?.totalPaid) ? totalPaymentCalculation(item?.payment?.approve?.totalPaid, item?.payment?.register?.totalPaid) : "",
          ...getFormDataHandler(item?.class?.form?.task_data, item?.formData),
          ...getFormDataHandler(item?.parentInfoForm?.task_data, item?.parentInfo, "Parent"),
          ...(item?.products?.reduce((acc, product) => {
            if (product?.quantity) acc[product.title] = product.quantity;
            if (product?.variant) Object.entries(product.variant).forEach(([k, v]) => { acc[`${product.title}-${k}`] = v; });
            return acc;
          }, {}) || {})
        };
        arr.push(data);
      });
    } else if (isDrawerOpen && !exportAllTable) {
      const data = {
        ["Class Name"]: drawerData?.class_name,
        ["Class Date"]: drawerData?.year,
        ["Registration Start Date"]: drawerData?.class_start_date ? formatDate({ date: drawerData?.class_start_date, formatType: "defaultWithUTC" }) : "",
        ["Registration End Date"]: drawerData?.class_end_date ? formatDate({ date: drawerData?.class_end_date, formatType: "defaultWithUTC" }) : "",
        ["Age Range"]: `${drawerData?.class_details?.ageStart} - ${drawerData?.class_details?.ageEnd}`,
        ["Non Member"]: drawerData?.allow_non_members_register,
        ["Participants"]: `${drawerData?.participantsDetails?.total} / ${drawerData?.class_details?.infiniteParticipants ? '∞' : drawerData?.class_details?.maximum_participants}`,
        ["Cost"]: numberFormat({ number: drawerData?.class_pricing?.total_cost || 0, decimal: 2, style: "currency" }),
      };
      arr.push(data);
    }
    else if (checkAll || check?.length > 0) {
      dataExport.map((item) => {
        const data = {
          ["Class Name"]: item?.class_name,
          ["Class Date"]: item?.year,
          ["Registration Start Date"]: item?.class_start_date ? formatDate({ date: item?.class_start_date, formatType: "defaultWithUTC" }) : "",
          ["Registration End Date"]: item?.class_end_date ? formatDate({ date: item?.class_end_date, formatType: "defaultWithUTC" }) : "",
          ["Age Range"]: `${item?.class_details?.ageStart} - ${item?.class_details?.ageEnd}`,
          ["Non Member"]: item?.allow_non_members_register,
          ["Participants"]: `${item?.participantsDetails?.total} / ${item?.class_details?.infiniteParticipants ? '∞' : item?.class_details?.maximum_participants}`,
          ["Cost"]: numberFormat({ number: item?.class_pricing?.total_cost || 0, decimal: 2, style: "currency" }),
        };
        arr.push(data);
      });
    }
    return arr;
  };
  const generateExcel = () => {
    let res = excelSheet()
    const worksheet = XLSX.utils.json_to_sheet(sanitizeRows(res));
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(
      workbook,
      getExportFileName()
    );
    setExportAllTable(false)
    setExportAllClassesParticipants(false)
  };
  const downloadExcel = () => {
    generateExcel();
  };
  useEffect(() => {
    if (exportAllClassesParticipantsLoading || exportAllLoading) return
    if (!exportAllTable && !exportAllClassesParticipants) return
    if (exportAllTable && drawerData?.participantsDetails?.total === 0) {
      toastr.info("validation", "No participants found")
      return;
    }
    getExportParticipantsData()
  }, [exportAllTable, exportAllClassesParticipants])

  useEffect(() => {
    if (!enableExportingParticipants) return
    downloadExcel()
    setEnableExportingParticipants(false)
  }, [enableExportingParticipants]);



  const mainUrl = window.location.origin;
  const getLink = (id) => {
    const checkDomain =
      mainUrl === 'https://admin.eztmpl.dev' ||
        mainUrl === 'http://localhost:3000'
        ? `https://shalom.eztmpl.dev/school/${id}`
        : mainUrl === 'https://admin.eztmpl.com'
          ? `https://demo.eztmpl.com/school/${id}`
          : mainUrl === 'https://admin.easyshul.com'
            ? `https://${orgKey}.easyshul.com/school/${id}`
            : mainUrl === 'https://admin-green.easyshul.com' ? `https://localhost.member-green.easyshul.com/school/${id}` : null;
    return checkDomain
  }


  const previewClass = (id) => {
    const link = getLink(id);
    window.open(link, '_blank');
  };


  return (
    <div
      className="w-100 school_class_list"
    >
      <div className={'family-table-container'}>
        <div className="current-class-table-container">
          <div className="header mt-5">
            <div
              style={{
                display: 'flex',
                padding: '20px 0px 10px 20px',
                alignItems: 'center',
                marginBottom: '18px',
              }}
              className="header__options"
            >
              <span className="finance-filter-serach-bar ">
                <SearchComp
                  value={searchValue}
                  setSearchText={handleInputChange}
                  placeholder="Search"
                  style={{ width: "20.5rem", backgroundColor: "#fff" }}
                />
              </span>
            </div>
            {(checkAll || check?.length > 0) && toggle && (
              <div className="new-class d-flex align-items-center">
                <MyButton
                  type="secondary"
                  content={
                    <div className="">
                      <ArchiveIcon style={{ height: '20px' }} />
                      <a
                        style={{
                          color: 'black',
                        }}
                      >
                        Archive
                      </a>
                    </div>
                  }
                  style={{
                    background: '#F4F6F9',
                    color: '#2555EF',
                    border: 'none',
                    marginRight: '1rem',
                  }}
                  onClick={handleArchiveButton}
                />
                <MyButton
                  type="secondary"
                  content={
                    <div className="d-flex align-items-center justify-content-center">
                      {exportAllLoading ? (
                        <CircularProgress size={20} />
                      ) : (
                        <>
                          <FileDownloadIcon style={{ height: '20px' }} />
                          <a
                            style={{
                              color: 'black',
                            }}
                          >
                            Export Classes
                          </a>
                        </>
                      )}
                    </div>
                  }
                  style={{
                    background: '#F4F6F9',
                    color: '#2555EF',
                    border: 'none',
                    marginRight: '1rem',
                    minWidth: '137px'
                  }}
                  onClick={downloadExcel}
                  disabled={exportAllLoading}
                />
                <MyButton
                  type="secondary"
                  content={
                    <div className="d-flex align-items-center justify-content-center">
                      {exportAllClassesParticipantsLoading ? (
                        <CircularProgress size={20} />
                      ) : (
                        <>
                          <FileDownloadIcon style={{ height: '20px' }} />
                          <a
                            style={{
                              color: 'black',
                            }}
                          >
                            Export Students
                          </a>
                        </>
                      )}
                    </div>
                  }
                  style={{
                    background: '#F4F6F9',
                    color: '#2555EF',
                    border: 'none',
                    marginRight: '1rem',
                    minWidth: '137px'
                  }}
                  onClick={(event) => {
                    setExportAllClassesParticipants((prev) => !prev);
                  }}
                  disabled={exportAllClassesParticipantsLoading}
                />
                <MyButton
                  type="secondary"
                  onClick={() => getExportData("print")}
                  content={
                    <div className="">
                      <PrintIcon style={{ height: '20px' }} />
                      <a
                        style={{
                          color: 'black',
                        }}
                      >
                        Print
                      </a>
                    </div>
                  }
                  style={{
                    background: '#F4F6F9',
                    color: '#2555EF',
                    border: 'none',
                    marginRight: '1rem',
                  }}
                />
                <span className="button-line"
                  style={{
                    height: 20,
                  }}
                />
                <MyButton
                  onClick={() => setOpenLetterModal(true)}
                  type="secondary"
                  content={
                    <div className="">
                      <ForwardToInboxIcon style={{ height: '20px' }} />
                      Send Letter: {checkAll ? count : check.length}
                    </div>
                  }
                  style={{
                    background: '#D3DDFC',
                    color: '#2555EF',
                    border: 'none',
                    marginRight: '1rem',
                    padding: '0px 25px',
                  }}
                />
              </div>
            )}
          </div>
          <div style={{ paddingLeft: '17px', paddingRight: '17px' }}>
            <TableContainer className="scroll-table">
              <Table aria-label="collapsible table ">
                <TableHead className="charges-table sticky-table-header">
                  <TableRow>
                    <TableCellHead
                      padding="checkbox"
                      className="class__header__cell checkbox_head"
                    >
                      {toggle &&
                        <CheckBox
                          onChange={(e) => {
                            if (!list?.length) return;
                            onCheckboxAllChange(e);
                          }}
                          text={""}
                          style={{ paddingTop: 8 }}
                          checked={checkAll}
                          isDisabled={!list?.length}
                        />
                      }
                    </TableCellHead>

                    <TableCellHead className="class__header__cell className_head">
                      <div>
                        CLASS NAME
                        {toggle && (
                          <IconButton>
                            <img
                              onClick={() => handleSort('name')}
                              src={sortImg}
                              alt="sort"
                            />
                          </IconButton>
                        )}
                      </div>
                    </TableCellHead>
                    <TableCellHead
                      align="left"
                      className="class__header__cell year__head"
                    >
                      <div>
                        DATE
                        {toggle && (
                          <IconButton>
                            <img
                              onClick={() => handleSort('date')}
                              src={sortImg}
                              alt="sort"
                            />
                          </IconButton>
                        )}
                      </div>
                    </TableCellHead>
                    <TableCellHead
                      align="left"
                      className="class__header__cell registration__head"
                    >
                      <div>
                        REGISTRATION
                        {toggle && (
                          <IconButton>
                            <img
                              onClick={() => handleSort('registration')}
                              src={sortImg}
                              alt="sort"
                            />
                          </IconButton>
                        )}
                      </div>
                    </TableCellHead>
                    <TableCellHead
                      align="left"
                      className="class__header__cell ageRane__head"
                    >
                      <div>
                        AGE RANGE
                        {toggle && (
                          <IconButton>
                            <img
                              onClick={() => handleSort('age')}
                              src={sortImg}
                              alt="sort"
                            />
                          </IconButton>
                        )}
                      </div>
                    </TableCellHead>
                    <TableCellHead
                      align="left"
                      className="class__header__cell nonMember__head"
                    >
                      <div>
                        NON-MEMBER
                        {toggle && (
                          <IconButton>
                            <img
                              onClick={() => handleSort('noneMember')}
                              src={sortImg}
                              alt="sort"
                            />
                          </IconButton>
                        )}
                      </div>
                    </TableCellHead>
                    <TableCellHead
                      align="left"
                      className="class__header__cell participants__head"
                    >
                      <div>
                        PARTICIPANTS
                        {toggle && (
                          <IconButton>
                            <img
                              onClick={() => handleSort('participant')}
                              src={sortImg}
                              alt="sort"
                            />
                          </IconButton>
                        )}
                      </div>
                    </TableCellHead>
                    <TableCellHead
                      align="left"
                      onClick={() => handleSort('total')}
                      className="class__header__cell total__cost"
                    >
                      <div>
                        COST
                        {toggle && (
                          <IconButton>
                            <img
                              src={sortImg}
                              onClick={() => handleSort('total')}
                              alt="sort"
                            />
                          </IconButton>
                        )}
                      </div>
                    </TableCellHead>
                    <TableCellHead
                      align="left"
                      className="class__header__cell sticky-header-column"
                    />
                  </TableRow>
                </TableHead>
                <TableBody
                  style={{
                    backgroundColor: 'white',
                  }}
                >
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        <div
                          className="user__loader"
                          style={{ height: '320px' }}
                        >
                          <Loader />
                        </div>
                      </TableCell>
                    </TableRow>
                  ) : list?.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        <h6 style={{ height: '320px', marginTop: '100px' }}>
                          No Classes Found
                        </h6>
                      </TableCell>
                    </TableRow>
                  ) : (
                    list?.map((row, i) => (
                      <React.Fragment>
                        <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                          <TableCellBody
                            className="main-width-class"
                            align="left"
                          >
                            {toggle && <CheckBox
                              onChange={(e) => onCheckboxChange(e, row)}
                              checked={checkAll ? true : check.some((obj) => obj._id === row?._id)}
                              text={""}
                              isDisabled={checkAll}
                            />}
                          </TableCellBody>
                          <TableCellBody
                            className="status-head main-width-class"
                            component="th"
                            scope="row"
                            onClick={() => {
                              dispatch(setClassName(row?.class_name))
                              history.push(`/class-participants/details/${row?._id}`)
                            }}
                          >
                            <div className="transaction-status">
                              <div style={{ width: 22 }}></div>
                              <div className="pl-0">
                                <div className="school-table-class-name">
                                  {row?.class_name}
                                </div>
                              </div>
                            </div>
                          </TableCellBody>
                          <TableCellBody
                            className="main-width-class"
                            align="left"
                            onClick={() => {
                              setDrawerData(row);
                              setIsDrawerOpen(true);
                            }}
                          >
                            <div className="table-row">
                              <p className="school-table-year">{row?.year}</p>
                            </div>
                          </TableCellBody>
                          <TableCellBody
                            className="account-header main-width-class"
                            align="left"
                            onClick={() => {
                              setDrawerData(row);
                              setIsDrawerOpen(true);
                            }}
                          >
                            <div className="school-table-registration text-nowrap">
                              {compareDate(row?.class_start_date)} -{' '}
                              {row?.always_available
                                ? 'Always available'
                                : compareDate(row?.class_end_date)}
                            </div>
                            {/* <div className="transaction-account-name ">{row?.Account?.name}</div> */}
                          </TableCellBody>
                          <TableCellBody
                            className="charged-head main-width-class"
                            align="left"
                            onClick={() => {
                              setDrawerData(row);
                              setIsDrawerOpen(true);
                            }}
                          >
                            <div
                              style={{
                                wordBreak: 'break-all',
                                whiteSpace: 'normal',
                              }}
                              className="school-table-dateRange"
                              title={row?.ageRange ?? 'N/A'}
                            >
                              {row?.class_details?.ageStart} -{' '}
                              {row?.class_details?.ageEnd}
                            </div>
                          </TableCellBody>
                          <TableCellBody
                            style={{
                              wordBreak: 'break-all',
                              whiteSpace: 'normal',
                            }}
                            className="paid-head main-width-class"
                            align="left"
                            onClick={() => {
                              setDrawerData(row);
                              setIsDrawerOpen(true);
                            }}
                          >
                            <div
                              className="transaction-paid table-row"
                              title={row?.allow_non_members_register ?? 'N/A'}
                            >
                              {row?.allow_non_members_register === true ? (
                                <CheckCircleIcon
                                  color="primary"
                                  className="ml-8"
                                />
                              ) : (
                                ''
                              )}
                            </div>{' '}
                          </TableCellBody>
                          <TableCellBody
                            className="ledger-head main-width-class"
                            align="left"
                          >
                            <ProgressBar
                              bgcolor={
                                row?.participantsDetails?.total > 100
                                  ? '#FA3372'
                                  : '#2555EF'
                              }
                              progress={calculateParticipantsPercentage(row)}
                              height={6}
                              id={row?._id}
                              class_name={row?.class_name}
                              value={row?.participantsDetails?.total}
                              maxValue={row?.class_details?.maximum_participants}
                              infinite={row?.class_details?.infiniteParticipants}

                            />
                          </TableCellBody>
                          <TableCellBody
                            className="transaction-head main-width-class"
                            align="right"
                            onClick={() => {
                              setDrawerData(row);
                              setIsDrawerOpen(true);
                            }}
                          >
                            <div
                              className="school-table-dateRange"
                              title={row?.class_pricing?.total_cost ?? 'N/A'}
                            >
                              {numberFormat({ number: +row?.class_pricing?.total_cost, decimal: 2, style: "currency" })}
                            </div>
                          </TableCellBody>
                          <TableCellBody
                            className="exp-action-head main-width-class sticky-body-column"
                            align="right"
                          >
                            <div
                              style={{ cursor: 'pointer', paddingleft: '0px' }}
                            >
                              <Action
                                action="class"
                                style={{ width: '16px' }}
                                onRegistrationLinkClick={() => previewClass(row?._id)}
                                onEditClick={() =>
                                  history.push(`/edit-class/${row?._id}`)
                                }
                                onDuplicateClick={() => {
                                  setDuplicateClassId(row?._id);
                                  setConfirmDialog(true);
                                }}
                                // onUpgradeClick={() => console.log('upgrade')}
                                onArchiveClick={
                                  toggle
                                    ? () => {
                                      setArchiveClassId([row?._id]);
                                      setArchiveStatus(true);
                                      setConfirmDialog(true);
                                    }
                                    : undefined
                                }
                                onActiveClick={
                                  !toggle
                                    ? () => {
                                      setArchiveClassId([row?._id]);
                                      setArchiveStatus(false);
                                      setConfirmDialog(true);
                                    }
                                    : undefined
                                }
                                onClassDeleteClick={() => {
                                  setDeleteClassId(row?._id);
                                  setConfirmDialog(true);
                                }}
                              />
                            </div>
                          </TableCellBody>
                        </TableRow>
                      </React.Fragment>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          <div className="pagination-custom mt-9">
            <Pagination
              count={Math.ceil(count / 30)}
              color="primary"
              variant="outlined"
              page={
                toggle
                  ? activeClassPage + 1
                  : archivedClassPage + 1
              }
              onChange={(event, value) => {
                if (toggle) {
                  setActiveClassPage(value - 1);
                } else {
                  setArchivedClassPage(value - 1);
                  getArchivedClasses(value);
                }
              }}
            />
          </div>
        </div>
        <div className="d-none">
          <div id="componentRef" ref={printTableRef}>
            <table style={{ padding: 10, margin: 10 }}>
              <thead>
                {columns_for_header?.map((column, index) => (
                  <th
                    style={{ border: "1px solid", textAlign: "center" }}
                    key={index}
                  >
                    {column?.headerName}
                  </th>
                ))}
              </thead>
              <tbody>
                {customCsvData?.map((item, index) => {
                  const d = {
                    ["Class Name"]: item?.className,
                    ["Date"]: item?.date,
                    ["Registration Start Date"]: item?.classStartDate,
                    ["Registration End Date"]: item?.classEndDate,
                    ["Age Range"]: item?.ageRange,
                    ["Non Member"]: item?.allowNonMembers ? "true" : "false",
                    ["participants"]: item?.participants,
                    ["Cost"]: item?.total_cost,

                  };
                  return (
                    <tr key={index}>
                      {Object?.values(d)?.map((objectValue, index) => (
                        <td
                          style={{
                            border: "1px solid",
                            padding: 5,
                          }}
                          key={index}
                        >
                          {objectValue}
                        </td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
        <AlertDialog
          open={confirmDialog}
          onDecline={() => {
            setDeleteClassId(null);
            setArchiveClassId([]);
            setDuplicateClassId(null);
            setConfirmDialog(false);
          }}
          onAccept={() => {
            if (deleteClassId) {
              deleteClass(deleteClassId);
            }
            if (archiveClassId.length > 0) {
              archiveClass(archiveClassId);
            }
            if (duplicateClassId) {
              duplicateClass(duplicateClassId);
            }
          }}
          title={'Are you sure?'}
          description={`Do you want to ${deleteClassId ? "delete" : duplicateClassId ? "duplicate" : toggle ? "archive" : "active"
            } this class?`}
          disabled={confirmLoading}
        />
        <RightDrawer
          open={isDrawerOpen}
          onClose={() => {
            setIsDrawerOpen(false);
          }}
        >
          <ClassDrawer
            drawerData={drawerData}
            setIsDrawerOpen={setIsDrawerOpen}
            setConfirmDialog={setConfirmDialog}
            setDeleteClassId={setDeleteClassId}
            setArchiveClassId={setArchiveClassId}
            toggle={toggle}
            setArchiveStatus={setArchiveStatus}
            setExportAllTable={setExportAllTable}
            exportAllTable={exportAllTable}

          />
        </RightDrawer>
        <Dialog
          open={openLetterModal}
          onClose={() => {
            setOpenLetterModal(false);
          }}
          PaperProps={{
            style: {
              width: "888px",
              height: "637px",
              overflowX: "hidden",
              borderRadius: "22px",
            },
          }}
          fullWidth
          maxWidth={"md"}
        >
          <SendLetter
            closeModal={() => {
              setOpenLetterModal(false);
            }}
            isMultiple={true}
            handleSendLetter={handleSendLetter}
            sendLetterLoading={sendLetterLoading}
            type="education"
          />
        </Dialog>
        <Dialog
          open={openSuccessModal}
          onClose={() => {
            setOpenSuccessModal(false);
          }}
          PaperProps={{
            style: {
              width: "800px",
              height: "400px",
              overflowX: "hidden",
              borderRadius: "22px",
            },
          }}
        >
          <SuccessModal
            title="Successfully Sent"
            description={`The total number of recipients is ${calculateTotalParticipants()}`}
            btnText="Done"
            btnAction={() => {
              setOpenSuccessModal(false);
            }}
            closeModal={() => {
              setOpenSuccessModal(false);
            }}
          />
        </Dialog>
      </div>
    </div>
  );
};

export default CurrentClasses;
